export class Logger {
  static log (message) {
    if (process.env.NODE_ENV !== 'development') {
      return
    }

    console.log(message)
  }
}
